<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Rekapitulasi Hasil
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Periode Dari</label>
          <b-form-datepicker
            v-model="filter.periode_dari"
            placeholder="Pilih Tanggal Mulai"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Periode Sampai</label>
          <b-form-datepicker
            v-model="filter.periode_sampai"
            placeholder="Pilih Tanggal Akhir"
            class="w-100"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="download()">Download</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BFormDatepicker,
} from 'bootstrap-vue'
import {
  exportRekapitulasiHasil,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      filter: {
        periode_dari: '',
        periode_sampai: ''
      },
      count: 0
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  methods: {
    async download() {
      this.showLoader = true
      const response = await exportRekapitulasiHasil(this.filter)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Rekapitulasi-Hasil.xlsx')
      document.body.appendChild(link)
      link.click()
      this.showLoader = false
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
